import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { useMixin } from '@cld/component-theme';
import { Icon, IconProps } from '@cld/icon';
import { theme } from '../theme';

export const DIRECTIONS = {
  UP: 'arrowDropUp',
  DOWN: 'arrowDropDown',
};

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export interface DecoratorContainerProps {
  hasTrailing: boolean;
}

const TrailingContainer = styled.div<DecoratorContainerProps>`
  display: flex;
  align-items: center;

  ${ButtonsContainer} {  
    ${({ hasTrailing }) => hasTrailing &&
    css`
        margin-right: ${theme.buttons.margin}
     `}
  }
`;

export interface IconAsButtonProps extends IconProps {
  isDisabled: boolean;
  buttonPaddingSize: string;
}

const IconAsButton = styled(Icon).attrs<IconAsButtonProps>({ tabIndex: 0 })`
  ${({ isDisabled }) => !isDisabled && 'cursor: pointer'};
  
  box-sizing: content-box;
  padding: 0 ${theme.buttons.padding};
  ${({ name, buttonPaddingSize }: IconAsButtonProps) => name === DIRECTIONS.UP ? `padding-top: ${buttonPaddingSize};` : ''}
  ${({ name, buttonPaddingSize }: IconAsButtonProps) => name === DIRECTIONS.DOWN ? `padding-bottom: ${buttonPaddingSize};` : ''}
  
  &:focus {
    outline: none;
  }
`;

export interface NumericDecoratorProps {
  onDownKey: () => void;
  onUpKey: () =>  void;
  isDisabled?: boolean;
  children?: ReactNode;
}

const NumericDecorator : FC<NumericDecoratorProps> = ({ isDisabled, onUpKey, onDownKey, children }) => {
  const buttonPaddingSize = useMixin(theme.buttons.padding);

  return (
    <TrailingContainer hasTrailing={!!children}>
      <ButtonsContainer>
        <IconAsButton
          name={DIRECTIONS.UP}
          size="xs"
          variant={isDisabled ? 'secondaryAlt' : 'contrastLow'}
          isDisabled={isDisabled}
          onClick={!isDisabled ? onUpKey : null}
          buttonPaddingSize={buttonPaddingSize}
        />
        <IconAsButton
          name={DIRECTIONS.DOWN}
          size="xs"
          variant={isDisabled ? 'secondaryAlt' : 'contrastLow'}
          isReadOnly={isDisabled}
          onClick={!isDisabled ? onDownKey : null}
          buttonPaddingSize={buttonPaddingSize}
        />
      </ButtonsContainer>
      {children}
    </TrailingContainer>
  );
};

export default NumericDecorator;
